import React from "react";

function Products() {
  return (
    <div>
      <h1>Продукты</h1>
      <p>Здесь будет список наших продуктов...</p>
    </div>
  );
}

export default Products;